import type { BasketItem } from "../types"
import styles from "../styles/widgetFin.module.css"

function fmtPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}

export function BasketItemRow({
  item,
  onRemove,
  onQtyChange,
}: {
  item: BasketItem
  onRemove: (itemId: string) => void
  onQtyChange: (itemId: string, qty: number) => void
}) {
  // Kit items prefer the matte speed-shape (more evocative than the bare
  // product photo). Add-ons / accessories use the featured product image
  // backfilled server-side in addToBasket. Falls back to a neutral
  // gradient so the row layout still aligns when both are missing.
  const imageSrc = item.colorRenders?.matte ?? item.image_url
  const imageBg = imageSrc
    ? `url(${imageSrc}) center/cover`
    : "linear-gradient(135deg, #2a2540, #1a1530)"
  return (
    <div className={styles["basket-row"]}>
      <div
        className={styles["basket-row-thumb"]}
        style={{ background: imageBg }}
        aria-hidden="true"
      />
      <div className={styles["basket-row-body"]}>
        <div className={styles["basket-row-title"]}>{item.title}</div>
        {item.source !== "direct" && (
          <div className={styles["basket-row-source"]}>
            {item.source === "build_car_kit" ? "From build" : "Add-on"}
          </div>
        )}
      </div>
      <div className={styles["basket-row-controls"]}>
        <div className={styles["basket-row-price"]}>{fmtPrice(item.price * item.quantity)}</div>
        <div className={styles["basket-row-qty"]}>
          <button
            type="button"
            aria-label="Decrease quantity"
            onClick={() => onQtyChange(item.id, item.quantity - 1)}
          >−</button>
          <span>{item.quantity}</span>
          <button
            type="button"
            aria-label="Increase quantity"
            onClick={() => onQtyChange(item.id, item.quantity + 1)}
          >+</button>
        </div>
        <button
          type="button"
          aria-label="Remove from cart"
          className={styles["basket-row-remove"]}
          onClick={() => onRemove(item.id)}
        >✕</button>
      </div>
    </div>
  )
}
